const invertedMessages = {
  'A pre-launch analysis is already running for this campaign.':
    'certs.prelaunch.footer.conflict',
  'Download Report': 'certs.prelaunch.footer.download',
  'Downloading…': 'certs.prelaunch.footer.downloading',
  'Re-trigger Analysis': 'certs.prelaunch.footer.retrigger',
  'Retriggering…': 'certs.prelaunch.footer.retriggering',
  Preview: 'certs.prelaunch.footer.preview',
  'Previewing…': 'certs.prelaunch.footer.previewing',
  'Launch Campaign': 'certs.prelaunch.footer.launch',
  'Launching…': 'certs.prelaunch.footer.launching',
  Close: 'certs.prelaunch.close.button',
};

export default invertedMessages;
